import {trackEvent} from "./eventTracker";

export const trackUpgradeCTA = (upgradeSection: string) => {
    trackEvent('upgrade_cta_clicked', {
        upgrade_section: upgradeSection,
    });
}

export const trackGenerationFailed = (failedType: 'audio' | 'video', workspaceId: number | string) => {
    trackEvent('generation_failed', {
        failed_type: failedType,
        workspace_id: workspaceId,
    })
}

export const trackSelfCustomCTA = (
    openLocation: 'project' | 'workspace_banner',
) => {
    trackEvent('self_custom_clicked', {
        open_location: openLocation,
    });
};

export const trackBannerInteraction = (
    actionType: 'clicked' | 'viewed',
    bannerId: string
) => {
    trackEvent('banner_interaction', {
        action_type: actionType,
        banner_id: bannerId,
    })
}
